<template>
  <div>
    <loading></loading>
    <div class="middle-box  text-center loginscreen animated fadeInDown">
      <div>
        <h3><img src="/static/img/common/logo.png" style="max-height: 40px;max-width:90%;"></h3>
        <div class="m-t">
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Account" v-model="user.account" required="">
          </div>
          <div class="form-group">
            <input type="password" class="form-control" placeholder="Password" v-model="user.password" required="">
          </div>
          <alert-compact :errors="errors"></alert-compact>
          <button type="submit" class="btn btn-primary block full-width m-b" @click="login">Login</button>
        </div>
        <p class="m-t">
          <small>Copyright (C) UNIQUERY Inc. All Rights Reserved.</small>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import Api from './service/Api.vue'
  import VueCookie from 'vue-cookie'

  export default {
    data () {
      return {
        user: {
          account: '',
          password: ''
        },
        errors: []
      }
    },
    created: function () {
      VueCookie.set('token', '', {domain: document.domain})
      VueCookie.set('scope', '', {domain: document.domain})

      if (process.env.NODE_ENV === 'development') {
        this.user.account = 'test'
        this.user.password = 'test'
      }
    },
    methods: {
      login: function () {
        var data = this.user
        this.$store.commit('modalShow', true)
        Api.login(data).then(this.loginSuccess).catch(this.loginFailure)
      },
      loginSuccess: function (response) {
        var token = response.data.token
        var scope = response.data.scope
        this.$store.commit('modalShow', false)
        if (token) {
          VueCookie.set('token', token, {domain: document.domain})
          VueCookie.set('scope', scope, {domain: document.domain})
          location.href = '/company/'
        }
      },
      loginFailure: function (error) {
        this.$store.commit('modalShow', false)
        this.errors = error.response.data.errors
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?3f617d39